import { Component, OnInit, Input } from '@angular/core';
import { ChartInputModel } from 'src/app/core/model/input/chart-input-model';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
})
export class BarChartComponent implements OnInit {
  private _input: ChartInputModel;
  @Input() set input(value: ChartInputModel) {
    this._input = value;
    this.prepareValues(this._input);
  }
  get input(): ChartInputModel {
    return this._input;
  }

  public barChartOptions = {
    responsive: true,
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            fontSize: 12,
            fontColor: 'black',
            fontFamily: 'Vazir',
          },
        },
      ],
      yAxes: [
        {
          position: 'left',
          ticks: {
            beginAtZero: true,
            fontSize: 12,
            fontColor: '#6e6e6e',
            maxTicksLimit: 5,
            fontFamily: 'Vazir',
            textAlign: 'left',
          },
          scaleLabel: {
            display: true,
            labelString: 'لیوان',
            fontSize: 12,
            fontColor: '#6e6e6e',
            fontFamily: 'Vazir',
          },
          gridLines: {
            display: false,
            drawBorder: false,
          },
        },
      ],
    },
    legend: { display: false },
  };
  public barChartLabels = ['', '', '', ''];
  public barChartType = 'bar';

  public barChartData = [
    {
      data: [0, 0, 0, 0],
      backgroundColor: '#0073ff',
      barThickness: 8,
    },
  ];

  constructor() {}

  ngOnInit() {}

  prepareValues(input: ChartInputModel) {
    // console.log(input);
    this.barChartLabels = input.labels;
    this.barChartData[0].data = input.data;
  }
}
